import { render, staticRenderFns } from "./MobileBottomNav.vue?vue&type=template&id=4c5a00d7"
import script from "./MobileBottomNav.vue?vue&type=script&lang=js"
export * from "./MobileBottomNav.vue?vue&type=script&lang=js"
import style0 from "./MobileBottomNav.vue?vue&type=style&index=0&id=4c5a00d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports